import { createFileRoute } from "@tanstack/react-router";
import { PageHeader } from "@/client/components/page-header";
import { apiQuery, useApiSuspenseQuery } from "@/client/lib/api";
import { ensurePage, pageHead } from "@/client/lib/page";
import { EstoqueClient } from "@/client/modules/estoque/estoque-client";
import Loading from "@/client/modules/estoque/loading";

export const Route = createFileRoute("/app/estoque")({
  loader: ({ context }) => ensurePage(context.queryClient, apiQuery("estoque", "page", {})),
  head: () => pageHead("Estoque"),
  pendingComponent: Loading,
  component: EstoquePage,
});

function EstoquePage() {
  const { data } = useApiSuspenseQuery("estoque", "page", {});
  return (
    <div className="mx-auto flex max-w-7xl flex-col gap-6">
      <PageHeader title="Estoque" description="Materiais do consultório — quantidade e reposição." />
      <EstoqueClient items={data} />
    </div>
  );
}
